import { COMPANY_VALUES_DATA } from "config/data";
import React from "react";

const CompanyValues = () => {
  return (
    <section className="company-values-section bg-gradiant">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="section-title text-white">
              <h1>Company Values</h1>
              <p>Transforming product ideas to digital reality.</p>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="row">
              {COMPANY_VALUES_DATA.map((value, index) => (
                <div className="col-lg-6" key={index}>
                  <div className="value-block">
                    <span className="img-wrap">
                      <img src={value.img} alt={value.title} />
                    </span>
                    <h6>{value.title}</h6>
                    <p>{value.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyValues;
